import moment from 'moment';

export default {
	quotations: {
	    data:[]
    },
	params: {
		filter_date: [
            moment().add('month', -1).format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
        ],
        code_voucher_type: '005',
		seller_id: null
	},
	sellers: [],
    preloader: false
}



// WEBPACK FOOTER //
// ./src/modules/quotations/state.js